if (!customElements.get("nss-gift")) {
    customElements.define(
        "nss-gift",
        class NSSGift extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                if (window.theme.nss_samples == true) {
                    this.innerHTML = `
                    <div class="nss-gift-toggle__content">
                        <svg class="nss-gift-toggle__icon" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.625" y="0.625" width="40" height="40" rx="20" stroke="#1E1A17" stroke-width="1.25"/>
                            <path d="M20.5684 8.9248H20.6816C22.9918 8.9248 24.7972 8.92484 26.2041 9.11426C27.6436 9.30752 28.7711 9.71058 29.6553 10.5947C30.5384 11.4789 30.9425 12.6065 31.1357 14.0449C31.3252 15.4528 31.3252 17.2582 31.3252 19.5684V19.6816C31.3252 21.9918 31.3252 23.7972 31.1357 25.2041C30.9425 26.6436 30.5394 27.7711 29.6553 28.6553C28.7711 29.5384 27.6435 29.9425 26.2051 30.1357C24.7972 30.3252 22.9918 30.3252 20.6816 30.3252H20.5684C18.2582 30.3252 16.4528 30.3252 15.0459 30.1357C13.6064 29.9425 12.4789 29.5394 11.5947 28.6553C10.7116 27.7711 10.3075 26.6435 10.1143 25.2051C9.92485 23.7972 9.9248 21.9918 9.9248 19.6816V19.5684C9.9248 17.2582 9.92484 15.4528 10.1143 14.0459C10.3075 12.6064 10.7106 11.4789 11.5947 10.5947C12.4789 9.71156 13.6065 9.30751 15.0449 9.11426C16.4528 8.92485 18.2582 8.9248 20.5684 8.9248ZM11.3252 20.375C11.3272 22.3681 11.3445 23.8547 11.501 25.0176C11.6737 26.3022 12.0052 27.0852 12.585 27.666C13.1658 28.2458 13.9478 28.5763 15.2324 28.749C16.3953 28.9045 17.8818 28.9228 19.875 28.9248H19.9248V21.749L19.8301 21.7266C19.4397 22.5075 18.8394 23.1641 18.0967 23.623C17.3539 24.082 16.4981 24.3254 15.625 24.3252C15.4393 24.3252 15.2612 24.2514 15.1299 24.1201C14.9986 23.9888 14.9248 23.8107 14.9248 23.625C14.9248 23.4393 14.9986 23.2612 15.1299 23.1299C15.2285 23.0313 15.3535 22.9653 15.4883 22.9385L15.625 22.9248C16.3679 22.925 17.089 22.6745 17.6719 22.2139C18.2547 21.7532 18.6655 21.1095 18.8369 20.3867L18.8516 20.3252H11.3252V20.375ZM22.4131 20.3867C22.5845 21.1095 22.9953 21.7532 23.5781 22.2139C24.161 22.6745 24.8821 22.925 25.625 22.9248C25.8107 22.9248 25.9888 22.9986 26.1201 23.1299C26.2514 23.2612 26.3252 23.4393 26.3252 23.625C26.3252 23.8107 26.2514 23.9888 26.1201 24.1201C25.9888 24.2514 25.8107 24.3252 25.625 24.3252L25.2988 24.3135C24.5398 24.2609 23.8033 24.0247 23.1533 23.623C22.4106 23.1641 21.8103 22.5075 21.4199 21.7266L21.3252 21.749V28.9248H21.375C23.3681 28.9228 24.8547 28.9055 26.0176 28.749C27.3022 28.5763 28.0852 28.2448 28.666 27.665C29.2458 27.0842 29.5763 26.3022 29.749 25.0176C29.9045 23.8547 29.9228 22.3682 29.9248 20.375V20.3252H22.3984L22.4131 20.3867ZM19.875 10.3252C17.8819 10.3272 16.3953 10.3445 15.2324 10.501C13.9478 10.6737 13.1648 11.0052 12.584 11.585C12.0042 12.1658 11.6737 12.9478 11.501 14.2324C11.3455 15.3953 11.3272 16.8818 11.3252 18.875V18.9248H15.6426L15.5781 18.8438C15.2239 18.4006 14.9687 17.8864 14.8311 17.3359C14.3013 15.2196 16.2196 13.3013 18.3359 13.8311C18.8864 13.9687 19.4006 14.2239 19.8438 14.5781L19.9248 14.6426V10.3252H19.875ZM17.9961 15.1895C17.7466 15.1271 17.4852 15.1306 17.2373 15.1992C16.9894 15.2679 16.763 15.3992 16.5811 15.5811C16.3992 15.763 16.2679 15.9894 16.1992 16.2373C16.1306 16.4852 16.1271 16.7466 16.1895 16.9961C16.3275 17.5455 16.6448 18.0335 17.0908 18.3828C17.5367 18.7319 18.0861 18.9225 18.6523 18.9248H19.9248V17.6514C19.9223 17.0852 19.732 16.5356 19.3828 16.0898C19.0336 15.644 18.5454 15.3274 17.9961 15.1895ZM24.0127 15.1992C23.7648 15.1306 23.5034 15.1271 23.2539 15.1895C22.7041 15.3275 22.2155 15.6453 21.8662 16.0918C21.5171 16.5382 21.3269 17.0886 21.3252 17.6553V18.9248H22.5977C23.1639 18.9225 23.7133 18.7319 24.1592 18.3828C24.6052 18.0335 24.9225 17.5455 25.0605 16.9961C25.1229 16.7466 25.1194 16.4852 25.0508 16.2373C24.9821 15.9894 24.8508 15.763 24.6689 15.5811C24.487 15.3992 24.2606 15.2679 24.0127 15.1992ZM21.3252 14.6426L21.4062 14.5781C21.8497 14.2237 22.3643 13.9686 22.915 13.8311C25.0304 13.3012 26.9487 15.2195 26.4199 17.3359C26.282 17.8864 26.0265 18.4007 25.6719 18.8438L25.6074 18.9248H29.9248V18.875C29.9228 16.8818 29.9045 15.3953 29.749 14.2324C29.5763 12.9478 29.2458 12.1658 28.666 11.585C28.0852 11.0052 27.3022 10.6737 26.0176 10.501C24.8547 10.3445 23.3681 10.3272 21.375 10.3252H21.3252V14.6426Z" fill="#1E1814" stroke="white" stroke-width="0.1"/>
                        </svg>
                        <div>
                            <div class="nss-gift-toggle__heading nss-subtitle">Add up to ${window.theme.nss_samples_max_quantity} free samples</div>
                            <div class="nss-gift-toggle__text nss-body-small">
                                <span class="js-nss-gift-toggle-count">0</span> of ${window.theme.nss_samples_max_quantity} added to your order
                            </div>
                        </div>
                        <svg class="nss-gift-toggle__arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 5L16 12.2917L9 19" stroke="#1E1814" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </div>`;

                    this.addEventListener('click', () => {
                        document.querySelector('nss-modal[data-modal="modal-samples"]')?.openDialog();
                    });

                    // Attach click listeners to "Add" buttons
                    const sampleAddButtons = document.querySelectorAll('nss-modal[data-modal="modal-samples"] .js-nss-samples-add-to-card');

                    sampleAddButtons.forEach(el => {
                        el.addEventListener('click', (e) => {
                            const variantId = parseInt(el.getAttribute('data-id'), 10);

                            let formData = {
                                'items': [{
                                    'id': variantId,
                                    'quantity': 1,
                                    'properties': {'_is_sample': true}
                                }]
                            };

                            // Disable all buttons immediately to prevent double-clicks
                            sampleAddButtons.forEach(item => item.setAttribute('disabled', 'disabled'));

                            fetch(window.Shopify.routes.root + 'cart/add.js', {
                                method: 'POST',
                                headers: {'Content-Type': 'application/json'},
                                body: JSON.stringify(formData)
                            })
                                .then(response => response.json())
                                .then(data => {

                                })
                                .catch((error) => {
                                    console.error('Error adding sample:', error);
                                    // On error, the Rebuy event listener below will naturally reset the button states
                                });
                        });
                    });
                }
            }
        }
    );
}

document.addEventListener('rebuy:smartcart.show', (event) => {
    cartCheck( event?.detail?.smartcart?.cart );
});
document.addEventListener('rebuy:cart.change', (event) => {
    cartCheck(event.detail?.cart.cart);
});

function cartCheck(cart) {


    if (!cart || !cart.items) return;
    // 1. Filter Items
    const sampleItems = cart.items.filter(item => item.properties && item.properties._is_sample);
    const regularItems = cart.items.filter(item => !(item.properties && item.properties._is_sample));

    const sampleCount = sampleItems.reduce((total, item) => total + item.quantity, 0);
    const hasRegularProduct = regularItems.length > 0;

    // 2. Subscription Check: Check if any item has a selling_plan (subscription)
    const hasSubscription = cart.items.some(item => item.selling_plan_allocation || item.selling_plan);

    if (hasSubscription) {
        document.body.classList.add('cart-has-subscription');
    } else {
        document.body.classList.remove('cart-has-subscription');
    }

    // 3. Logic: If ONLY samples exist, clear the cart
    if (sampleItems.length > 0 && !hasRegularProduct) {
        if (typeof rebuyCart.clearCart === 'function') {
            rebuyCart.clearCart();
        } else if (window.Rebuy?.Cart?.clearCart) {
            window.Rebuy.Cart.clearCart();
        }
        return;
    }

    // 4. Update the counter UI
    const countElement = document.querySelector('.js-nss-gift-toggle-count');
    if (countElement) {
        countElement.textContent = sampleCount;
    }

    // 5. Update Button States
    const buttons = document.querySelectorAll(
        'nss-modal[data-modal="modal-samples"] .js-nss-samples-add-to-card'
    );

    buttons.forEach((el) => {
        const variantId = parseInt(el.getAttribute('data-id'), 10);
        const isThisVariantAdded = sampleItems.some(item => item.id === variantId);

        if (isThisVariantAdded) {
            el.classList.add('is-added');
            el.setAttribute('disabled', 'disabled');
        } else if (!hasRegularProduct) {
            el.classList.remove('is-added');
            el.setAttribute('disabled', 'disabled');
        } else if (sampleCount >= (window.theme?.nss_samples_max_quantity || 2)) {
            el.classList.remove('is-added');
            el.setAttribute('disabled', 'disabled');
        } else {
            el.classList.remove('is-added');
            el.removeAttribute('disabled');
        }
    });

    // Initial check for subscription class on load
    if (cart && cart.items) {
        const hasSubscription = cart.items.some(item => item.selling_plan_allocation || item.selling_plan);
        document.body.classList.toggle('cart-has-subscription', hasSubscription);
    }
}
